<sm-options-content-layout optionsWidthClass="width300" mobileMode="overlay" contentStyleClass="flex-col width100p">
    <ng-template #options>
        <p-panel class="height100p full-height" [header]="app.t('ProjectPlanning.options')">
            <app-project-toolbar [forProjects]=true [project]="project">
            </app-project-toolbar>

            <sm-form [form]="form"></sm-form>
            @if (project != null) {
                <app-project-information class="mt-5" [project]="project" [stats]="stats"></app-project-information>
            }
        </p-panel>
    </ng-template>

    <ng-template #content>
        <div class="flex-item-fill flex-col height100p">
            <sm-table #tableComponent class="flex-item-fill height100p" [floatingFilter]=true [data]="table" headerAlign="center" columnWidthMode="contentNoExpand" [contentColumnMaxWidthRatio]="0.3" [(selection)]="selectedEvent"
                (onRowSelect)="rowSelected($event)" (onCellEditingStopped)="cellEdited($event)" (onRowDoubleClicked)="eventClicked($event)"></sm-table>
        </div>
    </ng-template>
</sm-options-content-layout>
